export default "__VITE_ASSET__DZp6CL8o__"